module.exports = __webpack_public_path__ + "static/media/home_icon.49c0cd1e.svg";